import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { InterceptService } from '../../core/_base/crud';
import { GuestFooterComponent } from './guest-footer/guest-footer.component';
import { GuestHeaderComponent } from './guest-header/guest-header.component';
import { GuestNoticeComponent } from './guest-notice/guest-notice.component';
import { GuestHomeComponent } from './guest-home/guest-home.component';

@NgModule({
  declarations: [GuestNoticeComponent, GuestHeaderComponent, GuestHomeComponent, GuestFooterComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatSelectModule,
    MatDatepickerModule,
    MatInputModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatIconModule,
    ReactiveFormsModule
  ],
  exports: [
    GuestHeaderComponent, GuestFooterComponent, GuestHomeComponent,
    GuestNoticeComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    InterceptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptService,
      multi: true
    }
  ]
})
export class SharedModule {
}
